var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMusic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "music",
    clipPath: "url(#clip0_0_134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9583 0.437503C11.9583 0.297376 11.8912 0.165728 11.7778 0.0834227C11.6644 0.00111778 11.5184 -0.0218834 11.3852 0.021559L4.67687 2.20906C4.49683 2.26777 4.375 2.43564 4.375 2.625V10.1003C3.72226 9.79754 2.80999 9.8634 1.98973 10.3406C0.807471 11.0284 0.264065 12.3102 0.775998 13.2037C1.28793 14.0971 2.66134 14.2639 3.8436 13.5761C4.75555 13.0456 5.25 12.25 5.24795 11.375H5.25V5.76211L11.0833 3.90605V7.76701C10.4306 7.46421 9.51832 7.53006 8.69806 8.00725C7.5158 8.69504 6.9724 9.97688 7.48433 10.8703C7.99626 11.7638 9.36968 11.9305 10.5519 11.2427C11.4639 10.7122 11.9957 9.82823 11.9563 9.04167H11.9583V0.437503ZM11.0833 2.98782V1.04034L5.25 2.94251V4.84389L11.0833 2.98782ZM10.9885 9.54682C11.1279 9.21807 11.0959 8.97076 11.0065 8.81467C10.9178 8.65989 10.7248 8.51124 10.3778 8.46911C10.0297 8.42686 9.58074 8.50605 9.13806 8.76358C8.69546 9.02106 8.4008 9.37452 8.26148 9.70318C8.12212 10.0319 8.1541 10.2792 8.24354 10.4353C8.33222 10.5901 8.52522 10.7388 8.87221 10.7809C9.22026 10.8231 9.66926 10.744 10.1119 10.4864C10.5545 10.2289 10.8492 9.87548 10.9885 9.54682ZM4.29813 11.148C4.38757 11.3041 4.41955 11.5514 4.28019 11.8802C4.14086 12.2088 3.84621 12.5623 3.40361 12.8198C2.96093 13.0773 2.51193 13.1565 2.16388 13.1142C1.81688 13.0721 1.62389 12.9234 1.5352 12.7687C1.44576 12.6126 1.41378 12.3653 1.55314 12.0365C1.69247 11.7079 1.98712 11.3544 2.42973 11.0969C2.8724 10.8394 3.3214 10.7602 3.66945 10.8024C4.01645 10.8446 4.20945 10.9932 4.29813 11.148Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic);
export default __webpack_public_path__ + "static/media/iconMusic.c8e628c05ecbb46ffb5e84080b8aa6ee.svg";
export { ForwardRef as ReactComponent };